import React, { useEffect } from 'react';
import './rops2025.css';
import { rops2025 } from '../../json/rops2025';

const Rops2025 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Reglas de Operación 2025</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Atención_Adultos_Mayores_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Atención a Adultos Mayores para el Ejercicio Fiscal 2025</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Fomento_Artesanal_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Fomento Artesanal para el Ejercicio Fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Fomento_Artesanal_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Atención_a_la_Juventud_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Atención a la Juventud para el Ejercicio Fiscal 2025</a></strong></h5>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Bienestar_de_Madres_Trabajadoras_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Madres Trabajadoras para el Ejercicio Fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Bienestar_de_Madres_Trabajadoras_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Bienestar_de_Personas_Cuidadoras_de_Personas_con_Discapacidad_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Personas Cuidadoras de Personas con Discapacidad para el Ejercicio Fiscal 2025</a></strong></h5>
                 <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Bienestar_de_Personas_Cuidadoras_de_Personas_con_Discapacidad_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
                


                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Celebración_Día_del_Niño_y_Niña_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa para la Celebración del Día del Niño y Niña para el Ejercicio Fiscal 2025</a></strong></h5>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Celebración_Día_de_las_Madres_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Celebración Día de las Madres para el Ejercicio Fiscal 2025</a></strong></h5>
               
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Desarrollo_Inclusivo_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Desarrollo Inclusivo para el Ejercicio Fiscal 2025</a></strong></h5>
                 <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Desarrollo_Inclusivo_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
               
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Atención_al_Pueblo_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Atención al Pueblo para el ejercicio fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Atención_al_Pueblo_EF_2025_Reforma_junio.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma junio de 2025</a><br />
                  </li>
                  </ul>
               
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Atención_a_Personas_Migrantes_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Atención a Personas Migrantes para el Ejercicio Fiscal 2025</a></strong></h5>
                 <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Atencion_a_Personas_Migrantes_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Fomento_al_Desarrollo_de_la_Participación_Social_para_el_Bienestar_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Fomento al Desarrollo de la Participación Social para el Bienestar para el Ejercicio Fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Fomento_al_Desarrollo_de_la_Participacion_Social_para_el_Bienestar_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
  
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Subsidio_al_Servicio_de_Verificación_Vehicular_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Subsidio al Servicio de Verificación Vehicular para el Ejercicio Fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Subsidio_al_Servicio_de_Verificación_Vehicular_EF_2025_Reforma_junio.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma junio de 2025</a><br />
                  </li>
                  </ul>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Estatal_apoyo_para_el_Bienestar_y_el_Desarrollo_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Estatal apoyo para el Bienestar y el Desarrollo para el ejercicio fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Apoyo_para_el_Bienestar_y_el_Desarrollo_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>
               
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Periodo_Invernal_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Periodo Invernal para el Ejercicio Fiscal 2025</a></strong></h5>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_Xantolo_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Xantolo para el Ejercicio Fiscal 2025</a></strong></h5>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/Modificacion_ROP_Xantolo_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Modificación Septiembre de 2025</a><br />
                  </li>
                  </ul>

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Rops2025;